<template>
  <NuxtLink
    v-if="to"
    :to="to"
    class="group inline-flex h-fit items-center gap-4 transition-colors"
    :aria-label="$t('back')"
    @click.prevent="goBack"
  >
    <IconArrowDown class="w-6 rotate-90 transition-transform ease-in-out group-hover:-translate-x-2" />
    <span>{{ $t('back') }}</span>
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps({
  to: {
    type: [String, Object],
    default: null,
  },
})

const router = useRouter()
function goBack() {
  if (router.options.history.state.back) {
    router.back()
    return
  }

  if (!props.to) {
    console.warn('No "to" prop provided for BackLink component.')
    return
  }
  router.push(props.to)
}
</script>
